/**
 * ToastManager - Manages the stacking of toast notifications
 *
 * This singleton tracks active toasts and calculates their vertical positions
 * so they don't overlap.
 */
class ToastManagerClass {
    toasts = new Map();
    GAP = 32; // Gap between toasts in pixels (includes visual spacing)
    register(toast) {
        this.toasts.set(toast.id, toast);
        this.updatePositions();
    }
    unregister(id) {
        this.toasts.delete(id);
        this.updatePositions();
    }
    updateHeight(id, height) {
        const toast = this.toasts.get(id);
        if (toast) {
            toast.height = height;
            this.updatePositions();
        }
    }
    updatePositions() {
        // Convert to array and sort by registration order (Map preserves insertion order)
        const toastsArray = Array.from(this.toasts.values());
        // Calculate positions from bottom up
        let cumulativeOffset = 0;
        // Iterate in reverse so newer toasts push older ones up
        for (let i = toastsArray.length - 1; i >= 0; i--) {
            const toast = toastsArray[i];
            // Call the position update callback
            toast.onPositionUpdate(cumulativeOffset);
            // Add this toast's height plus gap for the next toast
            cumulativeOffset += toast.height + this.GAP;
        }
    }
}
export const ToastManager = new ToastManagerClass();
